"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var kage_1 = require("../../kage");
var util_1 = require("../../util");
var cd_1 = require("./cd");
var mincho_1 = __importDefault(require("../mincho"));
function dfDrawFont(font, polygons, _a) {
    var a1 = _a.a1, x1 = _a.x1, y1 = _a.y1, x2 = _a.x2, y2 = _a.y2, x3 = _a.x3, y3 = _a.y3, x4 = _a.x4, y4 = _a.y4, a2_100 = _a.a2_100, a3_100 = _a.a3_100, haneAdjustment = _a.haneAdjustment, mageAdjustment = _a.mageAdjustment;
    switch (a1 % 100) {
        case 0:
            break;
        case 1: {
            if (a3_100 === 4 && haneAdjustment === 0 && mageAdjustment === 0) {
                var _b = (x1 === x2 && y1 === y2)
                    ? [0, font.kMage] // ?????
                    : util_1.normalize([x1 - x2, y1 - y2], font.kMage), dx1 = _b[0], dy1 = _b[1];
                var tx1 = x2 + dx1;
                var ty1 = y2 + dy1;
                cd_1.cdDrawLine(font, polygons, x1, y1, tx1, ty1, a2_100, 1);
                cd_1.cdDrawCurve(font, polygons, tx1, ty1, x2, y2, x2 - font.kMage * 2, y2 - font.kMage * 0.5, 1, 0);
            }
            else {
                cd_1.cdDrawLine(font, polygons, x1, y1, x2, y2, a2_100, a3_100);
            }
            break;
        }
        case 2:
        case 12: {
            if (a3_100 === 4 && haneAdjustment === 0 && mageAdjustment === 0) {
                var _c = (x2 === x3)
                    ? [0, -font.kMage] // ?????
                    : (y2 === y3)
                        ? [-font.kMage, 0] // ?????
                        : util_1.normalize([x2 - x3, y2 - y3], font.kMage), dx1 = _c[0], dy1 = _c[1];
                var tx1 = x3 + dx1;
                var ty1 = y3 + dy1;
                cd_1.cdDrawCurve(font, polygons, x1, y1, x2, y2, tx1, ty1, a2_100, 1);
                cd_1.cdDrawCurve(font, polygons, tx1, ty1, x3, y3, x3 - font.kMage * 2, y3 - font.kMage * 0.5, 1, 0);
            }
            else if (a3_100 === 5 && haneAdjustment === 0 && mageAdjustment === 0) {
                var tx1 = x3 + font.kMage;
                var ty1 = y3;
                var tx2 = tx1 + font.kMage * 0.5;
                var ty2 = y3 - font.kMage * 2;
                cd_1.cdDrawCurve(font, polygons, x1, y1, x2, y2, x3, y3, a2_100, 1);
                cd_1.cdDrawCurve(font, polygons, x3, y3, tx1, ty1, tx2, ty2, 1, 0);
            }
            else {
                cd_1.cdDrawCurve(font, polygons, x1, y1, x2, y2, x3, y3, a2_100, a3_100);
            }
            break;
        }
        case 3: {
            var _d = (x1 === x2 && y1 === y2)
                ? [0, font.kMage] // ?????
                : util_1.normalize([x1 - x2, y1 - y2], font.kMage), dx1 = _d[0], dy1 = _d[1];
            var tx1 = x2 + dx1;
            var ty1 = y2 + dy1;
            var _e = (x2 === x3 && y2 === y3)
                ? [0, -font.kMage] // ?????
                : util_1.normalize([x3 - x2, y3 - y2], font.kMage), dx2 = _e[0], dy2 = _e[1];
            var tx2 = x2 + dx2;
            var ty2 = y2 + dy2;
            cd_1.cdDrawLine(font, polygons, x1, y1, tx1, ty1, a2_100, 1);
            cd_1.cdDrawCurve(font, polygons, tx1, ty1, x2, y2, tx2, ty2, 1, 1);
            if (a3_100 === 5 && haneAdjustment === 0 && mageAdjustment === 0) {
                var tx3 = x3 - font.kMage;
                var ty3 = y3;
                var tx4 = x3 + font.kMage * 0.5;
                var ty4 = y3 - font.kMage * 2;
                cd_1.cdDrawLine(font, polygons, tx2, ty2, tx3, ty3, 1, 1);
                cd_1.cdDrawCurve(font, polygons, tx3, ty3, x3, y3, tx4, ty4, 1, 0);
            }
            else {
                cd_1.cdDrawLine(font, polygons, tx2, ty2, x3, y3, 1, a3_100);
            }
            break;
        }
        case 6: {
            if (a3_100 === 5 && haneAdjustment === 0 && mageAdjustment === 0) {
                var tx1 = x4 - font.kMage;
                var ty1 = y4;
                var tx2 = x4 + font.kMage * 0.5;
                var ty2 = y4 - font.kMage * 2;
                /*
                cdDrawCurve(x1, y1, x2, y2, (x2 + x3) / 2, (y2 + y3) / 2, a2, 1);
                cdDrawCurve((x2 + x3) / 2, (y2 + y3) / 2, x3, y3, tx1, ty1, 1, 1);
                 */
                cd_1.cdDrawBezier(font, polygons, x1, y1, x2, y2, x3, y3, tx1, ty1, a2_100, 1);
                cd_1.cdDrawCurve(font, polygons, tx1, ty1, x4, y4, tx2, ty2, 1, 0);
            }
            else {
                /*
                cdDrawCurve(x1, y1, x2, y2, (x2 + x3) / 2, (y2 + y3) / 2, a2, 1);
                cdDrawCurve((x2 + x3) / 2, (y2 + y3) / 2, x3, y3, x4, y4, 1, a3);
                 */
                cd_1.cdDrawBezier(font, polygons, x1, y1, x2, y2, x3, y3, x4, y4, a2_100, a3_100);
            }
            break;
        }
        case 7: {
            cd_1.cdDrawLine(font, polygons, x1, y1, x2, y2, a2_100, 1);
            cd_1.cdDrawCurve(font, polygons, x2, y2, x3, y3, x4, y4, 1, a3_100);
            break;
        }
        case 9: // may not be exist
            // kageCanvas[y1][x1] = 0;
            // kageCanvas[y2][x2] = 0;
            break;
        default:
            break;
    }
}
var Gothic = /** @class */ (function (_super) {
    __extends(Gothic, _super);
    function Gothic() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.shotai = kage_1.KShotai.kGothic;
        return _this;
    }
    Gothic.prototype.draw = function (polygons, stroke) {
        dfDrawFont(this, polygons, stroke);
    };
    return Gothic;
}(mincho_1.default));
exports.default = Gothic;
